/* "Produkter er bare begynnelsen" card row (about page) — Domino Wave hover.
   Hovering/focusing one card lifts + tilts it and sends a decaying ripple
   through its neighbours, each settling back with a slight overshoot. This
   is a dependency-free reimplementation (plain CSS transitions, no GSAP) of
   the effect, matching how every other hover animation on this site is
   built. Disabled below the 1000px breakpoint, where the row becomes a
   touch-scrollable strip instead (see .feelin-crosssell__row CSS). */
(function () {
  var row = document.querySelector('[data-domino-row]');
  if (!row) return;

  var cards = Array.from(row.querySelectorAll('.feelin-crosssell__card'));
  if (!cards.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BASE_LIFT = 14;
  var BASE_ROT = 8;
  var STAGGER = 55;
  var FALLOFF = 0.85;

  function touchLayoutActive() {
    return window.matchMedia('(max-width: 1000px)').matches;
  }

  function trigger(index) {
    if (touchLayoutActive()) return;
    cards.forEach(function (card, i) {
      var d = i - index;
      var ad = Math.abs(d);
      var falloff = 1 / (1 + ad * FALLOFF);
      card.style.transitionDelay = (ad * STAGGER) + 'ms';

      if (reduceMotion) {
        card.style.transform = 'scale(' + (i === index ? 1.03 : 1) + ')';
        return;
      }

      var lift = -BASE_LIFT * falloff;
      var rot = d === 0 ? 0 : Math.sign(d) * BASE_ROT * falloff;
      var scale = d === 0 ? 1.05 : 1;
      card.style.transform = 'translateY(' + lift + 'px) rotate(' + rot + 'deg) scale(' + scale + ')';
    });
  }

  function release() {
    cards.forEach(function (card) {
      card.style.transitionDelay = '0ms';
      card.style.transform = '';
    });
  }

  cards.forEach(function (card, i) {
    card.addEventListener('pointerenter', function () { trigger(i); });
    card.addEventListener('focus', function () { trigger(i); });
    card.addEventListener('pointerleave', release);
    card.addEventListener('blur', release);
  });
})();
